import React from 'react'
import styles from './WorkflowNav.module.scss'

function StepNav({ steps, currentStep, onStepChange }) {
  return (
    <div className={styles.stepNav} role="tablist" aria-label="Workflow steps">
      {steps.map((step, index) => {
        const isActive = step.id === currentStep
        const isCompleted = step.isCompleted && !isActive

        return (
          <button
            key={step.id}
            type="button"
            className={[
              styles.stepButton,
              isActive ? styles.active : '',
              isCompleted ? styles.completed : '',
              step.isUnlocked ? '' : styles.locked,
            ].join(' ')}
            onClick={() => step.isUnlocked && onStepChange(step.id)}
            disabled={!step.isUnlocked}
          >
            <span className={styles.stepIndex}>{index + 1}</span>
            <span className={styles.stepText}>
              <strong>{step.label}</strong>
              {step.helpText && <small>{step.helpText}</small>}
            </span>
          </button>
        )
      })}
    </div>
  )
}

export default React.memo(StepNav)
